import request from '@/services/utils/request'
import type { CollaborationBindingAuthorizeResponse, CollaborationBindingStatus } from './types'
import { buildCollaborationCallbackUri, resolveCollaborationReturnUrl } from '@/services/collaboration-login/session'

/**
 * 获取当前用户在当前企业的协同账号绑定状态。
 */
export function getCollaborationBindingStatuses() {
    return request({
        url: '/system/auth/collaboration-binding/status',
        method: 'GET',
        silent: true
    }) as Promise<{ data: CollaborationBindingStatus[] }>
}

/**
 * 发起 H5 协同账号绑定授权。
 */
export function authorizeCollaborationBinding(installationId: number, returnUrl = '/') {
    const query = new URLSearchParams({ noOauth2: '1', redirect: resolveCollaborationReturnUrl(returnUrl) })
    return request({
        url: '/system/auth/collaboration-binding/authorize',
        method: 'POST',
        data: {
            installationId,
            terminal: 'H5',
            callbackUri: buildCollaborationCallbackUri('/packageUser/pages/collaboration-binding/index', query)
        }
    }) as Promise<{ data: CollaborationBindingAuthorizeResponse }>
}

/**
 * 使用三方 OAuth 回传参数完成协同账号绑定。
 */
export function completeCollaborationBinding(code: string, state: string) {
    return request({
        authBootstrap: true,
        authReplay: false,
        url: '/system/auth/collaboration-binding/complete',
        silent: true,
        method: 'POST',
        data: {
            code,
            state
        }
    })
}

/**
 * 暂缓当前协同应用的绑定提醒。
 */
export function dismissCollaborationBinding(installationId: number) {
    return request({
        url: '/system/auth/collaboration-binding/dismiss',
        method: 'POST',
        data: {
            installationId
        },
        silent: true
    })
}
